import React from "react";

import Icon from "../../../../components/Icon";

// Barra flutuante que só existe com seleção: não ocupa espaço da lista à toa
// e, por flutuar, não empurra a tabela enquanto a pessoa marca os checkboxes.
// `actions`: [{ text, action }].
export const BulkActionsBar = ({ count, actions, onClear }) => {
    if (count === 0 || actions.length === 0) return null;

    return (
        <div className="finance-bulk-bar" role="toolbar" aria-label="Ações em lote">
            <span className="bulk-count">{count} {count === 1 ? 'selecionado' : 'selecionados'}</span>
            <span className="bulk-divider" />
            {actions.map(action => (
                <button type="button" key={action.text} className="bulk-action" onClick={action.action}>
                    {action.text}
                </button>
            ))}
            <span className="bulk-divider" />
            <button type="button" className="bulk-clear" onClick={onClear} aria-label="Limpar seleção" title="Limpar seleção">
                <Icon name="close" size={16} />
            </button>
        </div>
    );
};

export default BulkActionsBar;
